/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { IEventResolver, ISchemaFlowNodeTypeDefinitionMap, TEventHandler } from "@adapptio/lib-blueprint";

/**
 * Component Event Resolver
 */
export class ComponentEventResolver implements IEventResolver {
	/**
	 * Constructor
	 */
	public constructor(
		private nodeTypes: ISchemaFlowNodeTypeDefinitionMap,
		private eventHandlers: { [K: string]: TEventHandler }
	) {}

	/**
	 * Returns a map of flow node types for event handling
	 */
	public getEventNodeTypes(): ISchemaFlowNodeTypeDefinitionMap {
		return this.nodeTypes;
	}

	/**
	 * Returns event handler for a given type
	 */
	public getEventHandler(eventType: string): TEventHandler {
		return this.eventHandlers[eventType];
	}
}
